@if (config()) {
  <div class="parameter-pattern-input-config">
    @if (!hideLabel()) {
      <div class="parameter-pattern-input-config__title">{{ parameterTitle }}:</div>
    }
    <div class="parameter-pattern-input-config__wrapper">
      <mat-form-field
        class="parameter-pattern-input-config__select without-subscript small-form-field"
        appearance="outline"
      >
        <mat-label>Pulse Type</mat-label>
        <mat-select
          [value]="changedPulseType()"
          [disabled]="disabled()"
          (selectionChange)="onChangePulseType($event)"
        >
          @for (option of patterns() | keyvalue; track option) {
            <mat-option [value]="option.key" class="parameter-pattern-input-config__option">
              <span class="parameter-pattern-input-config__text" [innerHTML]="option.value"></span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field
        class="parameter-pattern-input-config__field without-subscript small-form-field"
        appearance="outline"
      >
        <mat-label>Pulse Length</mat-label>
        <input
          matInput
          type="number"
          [min]="pulseLengthMin()"
          [max]="pulseLengthMax()"
          [ngModel]="changedPulseLength()"
          [disabled]="disabled()"
          (ngModelChange)="onChangePulseLength($event)"
        />
      </mat-form-field>
      <mat-form-field
        class="parameter-pattern-input-config__field without-subscript small-form-field"
        appearance="outline"
      >
        <mat-label>Period Length</mat-label>
        <input
          matInput
          type="number"
          [min]="periodLengthMin()"
          [max]="periodLengthMax()"
          [ngModel]="changedPeriodLength()"
          [disabled]="disabled()"
          (ngModelChange)="onChangePeriodLength($event)"
        />
      </mat-form-field>
    </div>

    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-pattern-input-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && !disabled() && hasDelete()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickRemove()"
            class="parameter-pattern-input-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (value() && !readonly() && hasUndo() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickUndo()"
            class="parameter-pattern-input-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (hasClose() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
        </button>
      </div>
    }
    @if (showReset() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button (click)="onResetToFactory()" [matTooltip]="resetToFactoryTooltip()">
          <mat-icon color="warn">replay</mat-icon>
        </button>
      </div>
    }
  </div>
}
